<template>
  <div class="stat-card">
    <div class="stat-card-title">
      <span>{{ title }}</span>
    </div>
    <div class="stat-card-count">
      <span :style="{ color: countColor || 'inherit' }">{{ count }}</span>
    </div>
    <div class="stat-card-label">
      <span>{{ countLabel }}</span>
    </div>
    <div class="stat-card-action" v-if="!hideActionButton">
      <button class="btn-no-style" :style="{ color: buttonColor || countColor || '#00BF50' }" @click="$emit('action-button-clicked')">
        <span class="action-text">
          <i :class="actionButtonIcon"></i>
          {{ actionButtonText }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    count: {
      type: String,
      required: true
    },
    countLabel: {
      type: String,
      required: true
    },
    actionButtonText: {
      type: String,
      required: true
    },
    actionButtonIcon: {
      type: String,
      default: 'fa fa-eye'
    },
    countColor: {
      type: String,
      default: null
    },
    buttonColor: {
      type: String,
      default: null
    },
    hideActionButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.stat-card {
  min-width: 150px;
  max-width: 380px;
  width: 100%;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  margin: 0;
  min-height: 160px;
}

.stat-card-title {
  margin-bottom: 4px;
}

.stat-card-title span {
  font-size: 12px;
  font-weight: bold;
}

.stat-card-count {
  display: flex;
  justify-content: center;
  font-weight: bold;
  margin-top: 15px;
}

.stat-card-count span {
  font-size: 30px;
}

.stat-card-label {
  display: flex;
  justify-content: center;
  font-weight: bold;
  margin-top: 5px;
}

.stat-card-label span {
  font-size: 10px;
}

.stat-card-action {
  display: flex;
  justify-content: center;
  margin-top: auto;
  padding-top: 5px;
  min-height: 20px;
}

.btn-no-style {
  background: none;
  border: none;
  font: inherit;
  cursor: pointer;
  font-weight: bold;
}

.action-text {
  font-size: 10px;
}
</style>